import React from 'react'

const Jva_strRev = () => {
    return (
        <div className='container'>
            <td>
  

  <h1 class="h1">How to reverse String in Java</h1>
  <p>There are many ways to reverse String in Java. We can reverse String using StringBuffer, StringBuilder, iteration
    etc. Let's see the ways to reverse String in Java.</p>

  <h2 class="h2">1) By StringBuilder / StringBuffer</h2>

  <p class="filename">File: StringFormatter.java</p>
  <div class="containers">
    <div class="dp-highlighter">
      <div class="bar">
       
      <ul start="1" class="dp-j">
        <li class="alt"><span><span class="keywords">public</span><span>&nbsp;</span><span
              class="keywords">class</span><span>&nbsp;StringFormatter&nbsp;&#123;&nbsp;&nbsp;</span></span></li>
        <li class=""><span><span class="keywords">public</span><span>&nbsp;</span><span
              class="keywords">static</span><span>&nbsp;String&nbsp;reverseString(String&nbsp;str)&#123;&nbsp;&nbsp;</span></span>
        </li>
        <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;StringBuilder&nbsp;sb=<span
              class="keywords">new</span><span>&nbsp;StringBuilder(str);&nbsp;&nbsp;</span></span></li>
        <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;sb.reverse();&nbsp;&nbsp;</span></li>
        <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;<span
              class="keywords">return</span><span>&nbsp;sb.toString();&nbsp;&nbsp;</span></span></li>
        <li class=""><span>&#125;&nbsp;&nbsp;</span></li>
        <li class="alt"><span>&#125;&nbsp;&nbsp;</span></li>
      </ul>
      </div>
    </div>
  </div>
  <p class="filename">File: TestStringFormatter.java</p>
  <div class="containers">
    <div class="dp-highlighter">
      <div class="bar">
        
      <ul start="1" class="dp-j">
        <li class="alt"><span><span class="keywords">public</span><span>&nbsp;</span><span
              class="keywords">class</span><span>&nbsp;TestStringFormatter&nbsp;&#123;&nbsp;&nbsp;</span></span></li>
        <li class=""><span><span class="keywords">public</span><span>&nbsp;</span><span
              class="keywords">static</span><span>&nbsp;</span><span
              class="keywords">void</span><span>&nbsp;main(String[]&nbsp;args)&nbsp;&#123;&nbsp;&nbsp;</span></span></li>
        <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(StringFormatter.reverseString(<span
              class="plain">"my&nbsp;name&nbsp;is&nbsp;khan"</span><span>));&nbsp;&nbsp;</span></span></li>
        <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(StringFormatter.reverseString(<span
              class="plain">"I&nbsp;am&nbsp;sonoo&nbsp;jaiswal"</span><span>));&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></span>
        </li>
        <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&#125;&nbsp;&nbsp;</span></li>
        <li class=""><span>&#125;&nbsp;&nbsp;</span></li>
      </ul>
    </div>
  </div>
</div>
  <p>Output:</p>
  <div class="output">
    <pre>nahk si eman ym <br/>
  lawsiaj oonos ma I <br/>
  </pre>
  </div>

  <h2 class="h2">2) By Reverse Iteration</h2>

  <p class="filename">File: StringFormatter.java</p>
  <div class="containers">
    <div class="dp-highlighter">
      <div class="bar">
        
      <ul start="1" class="dp-j">
        <li class="alt"><span><span class="keywords">public</span><span>&nbsp;</span><span
              class="keywords">class</span><span>&nbsp;StringFormatter&nbsp;&#123;&nbsp;&nbsp;</span></span></li>
        <li class=""><span><span class="keywords">public</span><span>&nbsp;</span><span
              class="keywords">static</span><span>&nbsp;String&nbsp;reverseString(String&nbsp;str)&#123;&nbsp;&nbsp;</span></span>
        </li>
        <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;<span
              class="keywords">char</span><span>&nbsp;ch[]=str.toCharArray();&nbsp;&nbsp;</span></span></li>
        <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;String&nbsp;rev=<span
              class="plain">""</span><span>;&nbsp;&nbsp;</span></span></li>
        <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;<span class="keywords">for</span><span>(</span><span
              class="keywords">int</span><span>&nbsp;i=ch.length-</span><span
              class="number">1</span><span>;i&gt;=</span><span
              class="number">0</span><span>;i--)&#123;&nbsp;&nbsp;</span></span></li>
        <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;rev+=ch[i];&nbsp;&nbsp;</span></li>
        <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&#125;&nbsp;&nbsp;</span></li>
        <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;<span
              class="keywords">return</span><span>&nbsp;rev;&nbsp;&nbsp;</span></span></li>
        <li class="alt"><span>&#125;&nbsp;&nbsp;</span></li>
        <li class=""><span>&#125;&nbsp;&nbsp;</span></li>
      </ul>
    </div>
  </div>
  </div>
  <p class="filename">File: TestStringFormatter.java</p>
  <div class="containers">
    <div class="dp-highlighter">
      <div class="bar">
        
      <ul start="1" class="dp-j">
        <li class="alt"><span><span class="keywords">public</span><span>&nbsp;</span><span
              class="keywords">class</span><span>&nbsp;TestStringFormatter&nbsp;&#123;&nbsp;&nbsp;</span></span></li>
        <li class=""><span><span class="keywords">public</span><span>&nbsp;</span><span
              class="keywords">static</span><span>&nbsp;</span><span
              class="keywords">void</span><span>&nbsp;main(String[]&nbsp;args)&nbsp;&#123;&nbsp;&nbsp;</span></span></li>
        <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(StringFormatter.reverseString(<span
              class="plain">"my&nbsp;name&nbsp;is&nbsp;khan"</span><span>));&nbsp;&nbsp;</span></span></li>
        <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(StringFormatter.reverseString(<span
              class="plain">"I&nbsp;am&nbsp;sonoo&nbsp;jaiswal"</span><span>));&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></span>
        </li>
        <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&#125;&nbsp;&nbsp;</span></li>
        <li class=""><span>&#125;&nbsp;&nbsp;</span></li>
      </ul>
    </div>
  </div>
</div>
  <p>Output:</p>
  <div class="output">
    <pre>nahk si eman ym <br/>
  lawsiaj oonos ma I <br/>
  </pre>
  </div>



        
        
    </td>
    </div>
    )
}

export default Jva_strRev
